import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { FlexBoxCol as Col } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { ICustomDotsStyles } from '@r1-frontend/ui-react/components/NukaCarousel/DefaultDots/styled';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';

export const customDotsStyles: ICustomDotsStyles = {
    dot: {
        background: COLORS.GRAY_S,
        opacity: 1,
    },
    activeDot: {
        background: COLORS.GRAY_M,
    },
};

export const SCol = styled(Col)`
    padding: 12px;
`;

export const Wrapper = styled.div`
    width: 100%;
`;

export const BenefitsContainer = styled.div`
    width: 100%;
`;

export const BenefitItem = styled.div<{ isLandscape?: boolean, isSlide?: boolean }>`
    padding: ${({ isLandscape }) => isLandscape ? '8px' : '8px 8px 24px 8px'};
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.white};
    height: ${({ isSlide }) => isSlide ? '372px' : '100%'};
    align-content: baseline;
    overflow: hidden;

    ${({ isLandscape }) => isLandscape && `
        align-items: center;
        flex-direction: row-reverse;
        height: 263px;
        padding-left: 0;

        > ${Image} {
            width: 50%;
            height: 100%;
            border-radius: 0px ${BorderRadius.InnerBlockRadius} ${BorderRadius.InnerBlockRadius} 0px;
            align-self: baseline;
        }

        > ${Desc} {
            width: 50%;
        }

        > ${Title} {
            margin-top: 0;
        }
    `}
`;

export const Desc = styled.div`
    display: block;
    padding: 0 32px;
`;

export const Image = styled.div<{ bgImage: string, bgWebpImage: string }>`
    width: 100%;
    height: 170px;
    background: url(${({ bgWebpImage, bgImage }) => useProgressiveImage(bgWebpImage, { hasTimeout: true, timeoutDelay: 1 }, bgImage)}) no-repeat;
    background-size: cover;
    background-position: top center;
    border-radius: ${BorderRadius.InnerBlockRadius} ${BorderRadius.InnerBlockRadius} 0px 0px;
`;

export const Title = styled.p`
    ${FONTS.H4};
    color: ${COLORS.GRAY_DARK};
    margin-top: 24px;
`;

export const Text = styled.p`
    ${FONTS.XS};
    color: ${COLORS.GRAY_DARK};
    margin-top: 6px;
`;
